import React from "react";
import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import styles from "../../common/card.scss";

const lineChartImg = require('file!../../../img/demo/line-chart.png');

export default class StudioCard extends BaseComponent {
  constructor(props, context) {
    super(props);
  }

  handleClick() {
    this.context.router.replace("analyticsStudio/" + this.props.id);
  }

  flipCard(e) {
    if ($(e.target).hasClass("material-icons")) return;
    $(this.refs.flipper).toggleClass("flipped");
  }

  componentDidMount() {
    window.flipperTimeout += 60;
    var flipper = $(this.refs.flipper);

    flipper.addClass("flip-ready");

    setTimeout(() => {
      flipper.addClass("flipped").removeClass("flip-ready");
    }, window.flipperTimeout);
    this.publish(InternalEvent.App.HIDE_PRELOADER);
  }

  render() {
    return (
      <div className="col flip noslsect" onClick={this.flipCard}>
        <div className="flipper" ref="flipper">
          <div className="face front">
            <div className={styles.description} style={{height: "215px"}}>{this.props.description}</div>
            <div className={styles.actions}>
              <div className={styles.detailBtn} onClick={this.handleClick}>
                <i className="material-icons">add</i>
              </div>
            </div>
          </div>
          <div className="face back">
            <div className={styles.name}>
              <span>{this.props.title}</span>
            </div>
            <div className={styles.image}>
              <img src={lineChartImg}/>
            </div>
            <div className={styles.label}>FROM</div>
            <div className={styles.createdBy}>smash</div>
            <div className={styles.actions}>
              <div className={styles.detailBtn} onClick={this.handleClick}>
                <i className="material-icons">add</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


StudioCard.contextTypes = {
  router: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/analytic-studio/studios/studioCard.jsx